import API from './index';

const api = {
    getReportDetail({ params }) {
        return API.authAPI({
            url: '/approval/get-report-detail',
            method: 'GET',
            params: { ...params },
        });
    },
    saveMiscellaneous(data) {
        return API.authAPI({
            url: '/approval/save-miscellaneous',
            method: 'POST',
            data,
        });
    },
    submitMiscellaneous(data) {
        return API.authAPI({
            url: '/approval/submit-miscellaneous',
            method: 'POST',
            data,
        });
    },
    downloadDocument(data) {
        return API.authAPI({
            url: `/approval/download-supplementary/${data.id}`,
            method: 'GET',
            responseType: 'blob',
            timeout: 1000 * 60 * 10,
        });
    },
};

export default api;
